import React, { useState } from 'react';

export default function ProdutoForm({ onSubmit, onCancel, initialData }) {
  const isEdit = !!initialData;
  const [nome, setNome] = useState(initialData?.nome || '');
  const [descricao, setDescricao] = useState(initialData?.descricao || '');
  const [quantidade, setQuantidade] = useState(0);
  const [precoCusto, setPrecoCusto] = useState(initialData ? String(Number(initialData.preco_custo).toFixed(2)) : '');
  const [precoVenda, setPrecoVenda] = useState(initialData ? String(Number(initialData.preco).toFixed(2)) : '');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!nome.trim()) return;
    const data = {
      nome: nome.trim(),
      descricao: descricao.trim(),
      preco_custo: parseFloat(precoCusto) || 0,
      preco: parseFloat(precoVenda) || 0,
    };
    if (!isEdit) data.quantidade = Number(quantidade) || 0;
    onSubmit(data);
  };

  const margem = (parseFloat(precoVenda) || 0) - (parseFloat(precoCusto) || 0);

  return (
    <form className="fm" onSubmit={handleSubmit}>
      <input className="inp" placeholder="Nome *" value={nome} onChange={e => setNome(e.target.value)} required autoFocus={isEdit} />
      <input className="inp" placeholder="Descrição (opcional)" value={descricao} onChange={e => setDescricao(e.target.value)} />
      {!isEdit && (
        <input className="inp" type="number" placeholder="Qtd inicial" min={0} value={quantidade} onChange={e => setQuantidade(e.target.value)} />
      )}
      <div className="inp-r">
        <input className="inp" type="number" step="0.01" min={0} placeholder="Custo R$" value={precoCusto} onChange={e => setPrecoCusto(e.target.value)} />
        <input className="inp" type="number" step="0.01" min={0} placeholder="Venda R$" value={precoVenda} onChange={e => setPrecoVenda(e.target.value)} />
      </div>
      {(precoCusto || precoVenda) && (
        <div style={{ fontSize: 12, color: margem >= 0 ? 'var(--g)' : 'var(--r)', fontWeight: 600, paddingLeft: 2 }}>
          Margem: R$ {margem.toFixed(2)} {margem > 0 ? `(${((margem / (parseFloat(precoVenda) || 1)) * 100).toFixed(0)}%)` : ''}
        </div>
      )}
      <div className="btn-g" style={{ marginTop: 4 }}>
        <button className="btn btn1" type="submit">{isEdit ? 'Salvar alterações' : 'Cadastrar'}</button>
        <button className="btn btn3" type="button" onClick={onCancel}>Cancelar</button>
      </div>
    </form>
  );
}
